import React, { FC } from 'react';
import ScanResultComponent from 'common/components/ScanResult';
import { ScanResult, ScanStatus } from 'common/core/file_scan';
import { ForgeIcon } from '@tylertech/forge-react';

export interface AttachmentLinkProps {
  /** Name for the attachment to display to the user */
  displayName: string;

  /** URL for downloading the attachment */
  downloadUrl: string;

  /** Scan results for the attachment. */
  scanResult: ScanResult;
}

// This is double exported (here and as the default) for testing purposes
export const AttachmentLink: FC<AttachmentLinkProps> = (props: AttachmentLinkProps) => {
  const { displayName, downloadUrl, scanResult } = props;

  // Only render a link for scans which have passed or which were skipped due to file size
  /**
   * @TODO: Remove `ScanStatus.Unscanned` from `renderAsLink` when we backfill scans for pre-2021 files.
   * To address some customer concerns, unscanned status is added temporarily to allow users to download files
   * that have not been scanned due to the fact that they have been uploaded before implementation of corescan service.
   */
  const renderAsLink = [ScanStatus.Ok, ScanStatus.TooLarge, ScanStatus.Unscanned];
  const link = renderAsLink.includes(scanResult.state) ? (
    <a href={downloadUrl}>{displayName}</a>
  ) : (
    displayName
  );

  return (
    <>
      <span className="file-icon">
        <ForgeIcon name="file_outline" />
      </span>
      <span className="file-link">{link}</span>
      <span className="file-scan-result">
        <ScanResultComponent result={scanResult} />
      </span>
    </>
  );
};

export default AttachmentLink;
